<script>
import EditableTextArea from '@components/editables/editable-text-area.vue';
import { workoutComputed, workoutMethods } from '@state/helpers';

export default {
  components: {
    EditableTextArea,
  },
  props: {},
  data() {
    return {
      feedback: '',
    };
  },
  computed: {
    ...workoutComputed,
  },
  methods: {
    ...workoutMethods,
    done() {
      this.setUpdatePostWorkoutReview({
        ...this.selectedWorkout.programDayWorkout.clientInput.postWorkoutReview,
        anyOtherFeedback: this.feedback,
      });
      this.$emit('next-card');
    },
  },
};
</script>

<template>
  <div class="details-section">
    <div class="content">
      <div class="title-container">
        <p class="title">Amazing!</p>
        <p class="sub-title">You completed the workout. Great work! Please take a few minutes to tell me how the workout went.</p>
      </div>
      <div id="textareaWidth" class="actions">
        <p class="title">Any other feedback you would like to share?</p>
        <EditableTextArea
          id="motivation"
          placeholderTxt="  Start typing"
          :enableAutoExpand="true"
          :text="feedback"
          color="light"
          mode="edit"
          @update-editable-value="feedback = $event"
        />
      </div>
    </div>
    <BaseButton @click="done" class="button btn-primary large">All Done</BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.details-section {
  align-items: center;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding-bottom: 3rem;
  padding-top: 3rem;
  width: 100%;

  .content {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    width: 75%;

    @include media('xl', null) {
      width: 65%;
    }

    .title-container {
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    .title {
      color: #fff;
      font-family: $base-font-family;
      font-size: 40px;
      font-style: normal;
      font-weight: bold;
      line-height: 33px;
      margin-bottom: 2rem;
      @media screen and (min-width: 1100px) {
        @include calc-font-size(4.3);
      }
    }
    .sub-title {
      color: #fff;
      font-family: $proxima-nova;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: 21px;
      margin-bottom: 2rem;
      mix-blend-mode: normal;
      opacity: 0.7;
      text-align: center;
    }
    .actions {
      margin-bottom: 1.6rem;
      width: 100%;
      .title {
        color: #fff;
        font-family: $proxima-nova;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px;
        text-align: center;
      }
    }
    #motivation {
      // padding-left: 3rem;
      // padding-right: 3rem;
      ::v-deep textarea {
        border-block-end: 1px solid white;
        color: white;
        font-family: $proxima-nova;
        font-size: 32px;
        font-style: normal;
        font-weight: normal;
        line-height: 40px;
        &::placeholder {
          /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: white;
          font-family: $proxima-nova;
          font-size: 32px;
          font-style: normal;
          font-weight: normal;
          line-height: 5rem;
          opacity: 0.35;
        }
      }
      ::v-deep .widthIndecator {
        font-size: 32px;
      }
    }
  }
  .btn-primary {
    line-height: unset;
    -webkit-transition-duration: 0.3s;
    width: 50%;
    @include calc-font-size(1.4);
  }
}
</style>
